export const PERFORMANCE_CHART_NAME = 'Return';
export const PERFORMANCE_CHART_COLOR = '#007098';

export const BENCHMARK_CHART_NAME = 'Benchmark';
export const BENCHMARK_CHART_COLOR = '#9C8D49';

export const ALLOCATION_UPDATE_NAME = 'Allocation Update';
export const ALLOCATION_UPDATE_COLOR = '#007098';

export const PERFORMANCE_CHART_LEGEND = [
  {
    name: PERFORMANCE_CHART_NAME,
    color: PERFORMANCE_CHART_COLOR,
  },
  {
    name: BENCHMARK_CHART_NAME,
    color: BENCHMARK_CHART_COLOR,
  },
  {
    name: ALLOCATION_UPDATE_NAME,
    color: ALLOCATION_UPDATE_COLOR,
  },
];
